function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './TagsSelector.css';
import React from 'react';
export var TagsSelector = function TagsSelector(_ref) {
  var items = _ref.items,
    className = _ref.className,
    selectedIds = _ref.selectedIds,
    _onChange = _ref.onChange,
    limit = _ref.limit;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(className)
  }, items.map(function (item) {
    var isSelected = selectedIds.includes(item.id);
    return /*#__PURE__*/React.createElement(TagItem, _extends({
      key: item.id
    }, item, {
      isSelected: isSelected,
      onChange: function onChange() {
        return _onChange && _onChange(item.id);
      },
      disabled: !isSelected && limit === selectedIds.length
    }));
  }));
};
export default TagsSelector;
var commonStyles = "c1qi8smt";
var TagItem = function TagItem(_ref2) {
  var id = _ref2.id,
    text = _ref2.text,
    isSelected = _ref2.isSelected,
    disabled = _ref2.disabled,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "".concat(commonItemStyles, " ").concat(isSelected ? "".concat(commonItemStyles, "__selected") : "", " ").concat(disabled ? "".concat(commonItemStyles, "__disabled") : "")
  }, /*#__PURE__*/React.createElement("input", {
    className: "tag-item__hidden-radio",
    id: id,
    type: "checkbox",
    checked: isSelected,
    onChange: onChange,
    disabled: disabled
  }), text);
};
var commonItemStyles = "clw7ntv";